// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    font-family: Arial, Helvetica, sans-serif;
    background-color: #f0f2f5;
    margin: 0;
    padding: 0;
  }
  
  .dashboard {
    max-width: 1200px;
    margin: 0 auto;
    padding: 20px;
    background-color: white;
    font-family: 'Roboto Mono', monospace;
  }
  
  h1 {
    color: #002475;
    text-align: center;
  }
  
.period-tabs {
  display: flex;
  justify-content: center;
  margin-bottom: 20px;
}

.period-tabs button {
  background-color: #f0f0f0;
  border: none;
  padding: 10px 20px;
  margin: 0 5px;
  cursor: pointer;
  transition: background-color 0.3s;
  font-family: 'Roboto Mono', monospace;
}

.period-tabs button.active {
  background-color: #002475;
  color: white;
}
  
  .dashboard-content {
    display: flex;
    flex-direction: column;
    gap: 40px;
    border: 1px solid black;
    padding: 20px 20px 60px 20px; /* Increased bottom padding */
    background-color: white;
    position: relative;
    overflow: hidden;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
    border: none;
  }
  
  .data-table th, .data-table td {
    padding: 12px;
    text-align: left;
    border: none;
    border-bottom: 1px solid #eee;
  }
  
  .data-table th {
    background-color: transparent;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  
  .data-table tr:last-child td {
    border-bottom: none;
  }
  
  .data-table tr:hover {
    background-color: rgb(240, 240, 240);
  }
  
  .data-table .fees-earned {
    text-align: right;
  }
  
  .data-table .percent-change {
    text-align: right;
  }
  
  .data-table .percent-change.positive {
    color: green;
  }
  
  .data-table .percent-change.negative {
    color: red;
  }
  
  .loading, .error, .no-data {
    text-align: center;
    padding: 2rem;
    font-family: 'Roboto Mono', monospace;
    color: #002475;
  }
  
  .error {
    color: #d32f2f;
  }
  
  .no-data {
    color: #666;
  }
  
  @media (max-width: 768px) {
    .dashboard-content {
      grid-template-columns: 1fr;
    }
  }
  
  .recharts-wrapper {
    background-color: white !important;
    overflow: visible !important;
  }

  .recharts-cartesian-grid-horizontal line {
    stroke: #e0e0e0;
    stroke-dasharray: 10 10;  /* Increased dash length */
  }

  .recharts-cartesian-grid-vertical line {
    stroke: none;
  }

  .recharts-surface {
    background-color: white;
  }
  
  /* Add this new class for the chart container */
  .chart-container {
    position: relative;
    width: 100%;
    height: 800px;
    margin-bottom: 2rem;
    overflow: visible;
  }
  
  .recharts-xAxis .recharts-cartesian-axis-tick-value {
    text-overflow: ellipsis;
    width: 100px; /* Adjust based on your needs */
    overflow: hidden;
  }
  
  .data-table th[style*="cursor: pointer"]:hover {
    background-color: rgb(240, 240, 240);
  }

  /* Middle align volume and percent change column titles */
  .data-table th.volume,
  .data-table th.percent-change {
    text-align: center;
  }

  /* Center align volume values */
  .data-table td.volume {
    text-align: center;
  }

  /* Right align percent change values */
  .data-table td.percent-change {
    text-align: right;
  }

  /* Optional: Add some subtle styling to differentiate header and improve readability */
  .data-table thead {
    border-bottom: 2px solid #e0e0e0;
  }

  .data-table tbody tr:nth-child(even) {
    background-color: #f9f9f9;
  }

  /* Style for sortable headers */
  .data-table th[style*="cursor: pointer"]:hover {
    background-color: rgb(240, 240, 240);
  }
  
  .chart-watermark {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 40px;
    opacity: 0.1;
    pointer-events: none;
    z-index: 1;
    font-family: 'Libre Baskerville', serif;
    color: #002475;
    white-space: nowrap;
    -webkit-user-select: none;
            user-select: none;
  }
  
  .dashboard-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .dashboard-section h2 {
    margin-bottom: 10px;
  }

  .dashboard-header {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 40px;  /* Increased from 20px to 40px */
  }

  .logo {
    color: #002475;
    font-size: 24px;
    font-weight: bold;
    margin: 0;
    font-family: 'Libre Baskerville', serif;
  }

  .dashboard-title {
    color: #002475;
    font-size: 24px;
    font-weight: bold;
    text-align: center;
    margin: 20px 0;
  }

  .logo.asxn-logo {
    font-family: 'Libre Baskerville', serif;
    color: #002475;
    font-size: 24px;
    font-weight: bold;
    margin: 0;
  }

  .logo-link {
    text-decoration: none;
    position: relative;
    display: inline-block;
  }

  .logo-link::after {
    content: '';
    position: absolute;
    width: 0;
    height: 1px;
    bottom: -4px;
    left: 50%;
    background-color: #002475;
    transition: all 0.3s ease-in-out;
  }

  .logo-link:hover::after {
    width: 100%;
    left: 0;
  }

  /* Remove any conflicting styles */
  .logo-link, .logo-link:hover, .logo-link::before, .logo-link::after {
    border: none;
    background-image: none;
  }

  .data-source {
    text-align: center;
    padding: -5px;
    font-size: 14px;
    color: #666;
    font-style: italic;
    font-family: 'Roboto Mono', monospace;
  }

  /* Center align category values */
  .data-table td.category {
    text-align: center;
  }

  .custom-tooltip {
    background: white;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
  }

  .custom-tooltip p {
    margin: 0;
    padding: 2px 0;
    font-family: 'Roboto Mono', monospace;
  }

  .custom-tooltip .label {
    font-weight: bold;
    color: #002475;
  }

  .custom-tooltip .value,
  .custom-tooltip .share,
  .custom-tooltip .token {
    color: #666;
  }

  .chart-container {
    position: relative;
    width: 100%;
    margin-bottom: 2rem;
  }

  .chart-watermark {
    position: absolute;
    top: 10px;
    right: 10px;
    font-family: 'Roboto Mono', monospace;
    color: rgba(0, 36, 117, 0.1);
    font-size: 24px;
    font-weight: bold;
    pointer-events: none;
  }

  .market-data-table-section {
    margin-top: 40px;
    margin-bottom: 40px;
  }
  
  .data-table-container {
    max-height: 400px;
    overflow-y: auto;
    margin: 20px;
  }
  
  .data-table {
    width: 100%;
    border-collapse: collapse;
    background: white;
  }
  
  .data-table th,
  .data-table td {
    padding: 12px;
    text-align: left;
    border: none;
    border-bottom: 1px solid #eee;
  }
  
  .data-table th {
    background-color: transparent;
    font-weight: 600;
    position: sticky;
    top: 0;
    z-index: 1;
  }
  
  .data-table tr:last-child td {
    border-bottom: none;
  }
  
  .data-table tr:hover {
    background-color: rgb(240, 240, 240);
  }
  
  .sortable-header {
    -webkit-user-select: none;
            user-select: none;
  }
  
  .data-table tr:hover {
    background-color: rgb(240, 240, 240);
  } 

  .charts-container {
    padding: 20px;
    max-width: 1400px;
    margin: 0 auto;
    width: 95%;
    background: white;
    border-color: gray;
    border-radius: 8px;
  }

  .chart-column {
    flex: 1 1;
    min-width: 0;
    background: transparent;
    padding: 20px 10px;
    border-radius: 0;
    box-shadow: none;
  }

  .charts-row {
    display: flex;
    gap: 20px;
    margin-bottom: 30px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;  /* Add rounded corners */
  }

  .chart-single {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: none;
    margin-bottom: 30px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
  }

  .market-data-table-section {
    margin: 30px 0;
    padding: 20px;
    background: white;
    /* border-radius: 8px; */
    box-shadow: none;
    border: 1px solid black;  
  }

  .data-table-container {
    max-height: 400px;
    overflow-y: auto;
  }

  .data-table {
    width: 100%;
    border-collapse: collapse;
  }

  .data-table th {
    position: sticky;
    top: 0;
    z-index: 1;
    cursor: pointer;
    background: white;
  }

  .data-table th,
  .data-table td {
    padding: 12px;
    text-align: left;
    border: none;
    border-bottom: 1px solid #eee;
  }

  .data-table tr:hover {
    background-color: rgb(240, 240, 240);
  }

  @media (max-width: 1024px) {
    .charts-row {
      flex-direction: column;
    }
    
    .chart-column {
      width: 100%;
      border: 1px solid #e0e0e0;
    }
  }

  /* Ensure no other borders or shadows */
  .data-table-container {
    box-shadow: none;
    border: none;
  }`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,yBAAyB;IACzB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,qCAAqC;EACvC;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;AAEF;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;EAEE;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,4BAA4B,EAAE,6BAA6B;IAC3D,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,qCAAqC;IACrC,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE;MACE,0BAA0B;IAC5B;EACF;;EAEA;IACE,kCAAkC;IAClC,4BAA4B;EAC9B;;EAEA;IACE,eAAe;IACf,uBAAuB,GAAG,0BAA0B;EACtD;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA,+CAA+C;EAC/C;IACE,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;IACvB,YAAY,EAAE,+BAA+B;IAC7C,gBAAgB;EAClB;;EAEA;IACE,oCAAoC;EACtC;;EAEA,yDAAyD;EACzD;;IAEE,kBAAkB;EACpB;;EAEA,+BAA+B;EAC/B;IACE,kBAAkB;EACpB;;EAEA,sCAAsC;EACtC;IACE,iBAAiB;EACnB;;EAEA,sFAAsF;EACtF;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA,+BAA+B;EAC/B;IACE,oCAAoC;EACtC;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,eAAe;IACf,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,uCAAuC;IACvC,cAAc;IACd,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB,GAAG,gCAAgC;EACxD;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,SAAS;IACT,uCAAuC;EACzC;;EAEA;IACE,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;EAChB;;EAEA;IACE,uCAAuC;IACvC,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,qBAAqB;IACrB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,YAAY;IACZ,SAAS;IACT,yBAAyB;IACzB,gCAAgC;EAClC;;EAEA;IACE,WAAW;IACX,OAAO;EACT;;EAEA,kCAAkC;EAClC;IACE,YAAY;IACZ,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,qCAAqC;EACvC;;EAEA,iCAAiC;EACjC;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,cAAc;IACd,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;IACjB,cAAc;EAChB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,qCAAqC;IACrC,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,6BAA6B;IAC7B,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,yBAAiB;YAAjB,iBAAiB;EACnB;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB,GAAG,wBAAwB;EAC/C;;EAEA;IACE,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,yBAAyB;EAC3B;;EAEA;IACE,gBAAgB;IAChB,MAAM;IACN,UAAU;IACV,eAAe;IACf,iBAAiB;EACnB;;EAEA;;IAEE,aAAa;IACb,gBAAgB;IAChB,YAAY;IACZ,6BAA6B;EAC/B;;EAEA;IACE,oCAAoC;EACtC;;EAEA;IACE;MACE,sBAAsB;IACxB;;IAEA;MACE,WAAW;MACX,yBAAyB;IAC3B;EACF;;EAEA,uCAAuC;EACvC;IACE,gBAAgB;IAChB,YAAY;EACd","sourcesContent":["body {\n    font-family: Arial, Helvetica, sans-serif;\n    background-color: #f0f2f5;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .dashboard {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 20px;\n    background-color: white;\n    font-family: 'Roboto Mono', monospace;\n  }\n  \n  h1 {\n    color: #002475;\n    text-align: center;\n  }\n  \n.period-tabs {\n  display: flex;\n  justify-content: center;\n  margin-bottom: 20px;\n}\n\n.period-tabs button {\n  background-color: #f0f0f0;\n  border: none;\n  padding: 10px 20px;\n  margin: 0 5px;\n  cursor: pointer;\n  transition: background-color 0.3s;\n  font-family: 'Roboto Mono', monospace;\n}\n\n.period-tabs button.active {\n  background-color: #002475;\n  color: white;\n}\n  \n  .dashboard-content {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    border: 1px solid black;\n    padding: 20px 20px 60px 20px; /* Increased bottom padding */\n    background-color: white;\n    position: relative;\n    overflow: hidden;\n  }\n\n  .data-table {\n    width: 100%;\n    border-collapse: collapse;\n    border: none;\n  }\n  \n  .data-table th, .data-table td {\n    padding: 12px;\n    text-align: left;\n    border: none;\n    border-bottom: 1px solid #eee;\n  }\n  \n  .data-table th {\n    background-color: transparent;\n    font-weight: 600;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n  \n  .data-table tr:last-child td {\n    border-bottom: none;\n  }\n  \n  .data-table tr:hover {\n    background-color: rgb(240, 240, 240);\n  }\n  \n  .data-table .fees-earned {\n    text-align: right;\n  }\n  \n  .data-table .percent-change {\n    text-align: right;\n  }\n  \n  .data-table .percent-change.positive {\n    color: green;\n  }\n  \n  .data-table .percent-change.negative {\n    color: red;\n  }\n  \n  .loading, .error, .no-data {\n    text-align: center;\n    padding: 2rem;\n    font-family: 'Roboto Mono', monospace;\n    color: #002475;\n  }\n  \n  .error {\n    color: #d32f2f;\n  }\n  \n  .no-data {\n    color: #666;\n  }\n  \n  @media (max-width: 768px) {\n    .dashboard-content {\n      grid-template-columns: 1fr;\n    }\n  }\n  \n  .recharts-wrapper {\n    background-color: white !important;\n    overflow: visible !important;\n  }\n\n  .recharts-cartesian-grid-horizontal line {\n    stroke: #e0e0e0;\n    stroke-dasharray: 10 10;  /* Increased dash length */\n  }\n\n  .recharts-cartesian-grid-vertical line {\n    stroke: none;\n  }\n\n  .recharts-surface {\n    background-color: white;\n  }\n  \n  /* Add this new class for the chart container */\n  .chart-container {\n    position: relative;\n    width: 100%;\n    height: 800px;\n    margin-bottom: 2rem;\n    overflow: visible;\n  }\n  \n  .recharts-xAxis .recharts-cartesian-axis-tick-value {\n    text-overflow: ellipsis;\n    width: 100px; /* Adjust based on your needs */\n    overflow: hidden;\n  }\n  \n  .data-table th[style*=\"cursor: pointer\"]:hover {\n    background-color: rgb(240, 240, 240);\n  }\n\n  /* Middle align volume and percent change column titles */\n  .data-table th.volume,\n  .data-table th.percent-change {\n    text-align: center;\n  }\n\n  /* Center align volume values */\n  .data-table td.volume {\n    text-align: center;\n  }\n\n  /* Right align percent change values */\n  .data-table td.percent-change {\n    text-align: right;\n  }\n\n  /* Optional: Add some subtle styling to differentiate header and improve readability */\n  .data-table thead {\n    border-bottom: 2px solid #e0e0e0;\n  }\n\n  .data-table tbody tr:nth-child(even) {\n    background-color: #f9f9f9;\n  }\n\n  /* Style for sortable headers */\n  .data-table th[style*=\"cursor: pointer\"]:hover {\n    background-color: rgb(240, 240, 240);\n  }\n  \n  .chart-watermark {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    font-size: 40px;\n    opacity: 0.1;\n    pointer-events: none;\n    z-index: 1;\n    font-family: 'Libre Baskerville', serif;\n    color: #002475;\n    white-space: nowrap;\n    user-select: none;\n  }\n  \n  .dashboard-section {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .dashboard-section h2 {\n    margin-bottom: 10px;\n  }\n\n  .dashboard-header {\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    margin-bottom: 40px;  /* Increased from 20px to 40px */\n  }\n\n  .logo {\n    color: #002475;\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n    font-family: 'Libre Baskerville', serif;\n  }\n\n  .dashboard-title {\n    color: #002475;\n    font-size: 24px;\n    font-weight: bold;\n    text-align: center;\n    margin: 20px 0;\n  }\n\n  .logo.asxn-logo {\n    font-family: 'Libre Baskerville', serif;\n    color: #002475;\n    font-size: 24px;\n    font-weight: bold;\n    margin: 0;\n  }\n\n  .logo-link {\n    text-decoration: none;\n    position: relative;\n    display: inline-block;\n  }\n\n  .logo-link::after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 1px;\n    bottom: -4px;\n    left: 50%;\n    background-color: #002475;\n    transition: all 0.3s ease-in-out;\n  }\n\n  .logo-link:hover::after {\n    width: 100%;\n    left: 0;\n  }\n\n  /* Remove any conflicting styles */\n  .logo-link, .logo-link:hover, .logo-link::before, .logo-link::after {\n    border: none;\n    background-image: none;\n  }\n\n  .data-source {\n    text-align: center;\n    padding: -5px;\n    font-size: 14px;\n    color: #666;\n    font-style: italic;\n    font-family: 'Roboto Mono', monospace;\n  }\n\n  /* Center align category values */\n  .data-table td.category {\n    text-align: center;\n  }\n\n  .custom-tooltip {\n    background: white;\n    padding: 10px;\n    border: 1px solid #ddd;\n    border-radius: 4px;\n  }\n\n  .custom-tooltip p {\n    margin: 0;\n    padding: 2px 0;\n    font-family: 'Roboto Mono', monospace;\n  }\n\n  .custom-tooltip .label {\n    font-weight: bold;\n    color: #002475;\n  }\n\n  .custom-tooltip .value,\n  .custom-tooltip .share,\n  .custom-tooltip .token {\n    color: #666;\n  }\n\n  .chart-container {\n    position: relative;\n    width: 100%;\n    margin-bottom: 2rem;\n  }\n\n  .chart-watermark {\n    position: absolute;\n    top: 10px;\n    right: 10px;\n    font-family: 'Roboto Mono', monospace;\n    color: rgba(0, 36, 117, 0.1);\n    font-size: 24px;\n    font-weight: bold;\n    pointer-events: none;\n  }\n\n  .market-data-table-section {\n    margin-top: 40px;\n    margin-bottom: 40px;\n  }\n  \n  .data-table-container {\n    max-height: 400px;\n    overflow-y: auto;\n    margin: 20px;\n  }\n  \n  .data-table {\n    width: 100%;\n    border-collapse: collapse;\n    background: white;\n  }\n  \n  .data-table th,\n  .data-table td {\n    padding: 12px;\n    text-align: left;\n    border: none;\n    border-bottom: 1px solid #eee;\n  }\n  \n  .data-table th {\n    background-color: transparent;\n    font-weight: 600;\n    position: sticky;\n    top: 0;\n    z-index: 1;\n  }\n  \n  .data-table tr:last-child td {\n    border-bottom: none;\n  }\n  \n  .data-table tr:hover {\n    background-color: rgb(240, 240, 240);\n  }\n  \n  .sortable-header {\n    user-select: none;\n  }\n  \n  .data-table tr:hover {\n    background-color: rgb(240, 240, 240);\n  } \n\n  .charts-container {\n    padding: 20px;\n    max-width: 1400px;\n    margin: 0 auto;\n    width: 95%;\n    background: white;\n    border-color: gray;\n    border-radius: 8px;\n  }\n\n  .chart-column {\n    flex: 1;\n    min-width: 0;\n    background: transparent;\n    padding: 20px 10px;\n    border-radius: 0;\n    box-shadow: none;\n  }\n\n  .charts-row {\n    display: flex;\n    gap: 20px;\n    margin-bottom: 30px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;  /* Add rounded corners */\n  }\n\n  .chart-single {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: none;\n    margin-bottom: 30px;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n  }\n\n  .market-data-table-section {\n    margin: 30px 0;\n    padding: 20px;\n    background: white;\n    /* border-radius: 8px; */\n    box-shadow: none;\n    border: 1px solid black;  \n  }\n\n  .data-table-container {\n    max-height: 400px;\n    overflow-y: auto;\n  }\n\n  .data-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n\n  .data-table th {\n    position: sticky;\n    top: 0;\n    z-index: 1;\n    cursor: pointer;\n    background: white;\n  }\n\n  .data-table th,\n  .data-table td {\n    padding: 12px;\n    text-align: left;\n    border: none;\n    border-bottom: 1px solid #eee;\n  }\n\n  .data-table tr:hover {\n    background-color: rgb(240, 240, 240);\n  }\n\n  @media (max-width: 1024px) {\n    .charts-row {\n      flex-direction: column;\n    }\n    \n    .chart-column {\n      width: 100%;\n      border: 1px solid #e0e0e0;\n    }\n  }\n\n  /* Ensure no other borders or shadows */\n  .data-table-container {\n    box-shadow: none;\n    border: none;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
